import { useState } from "react";

const UserDelegateReadOnlyRow = ({ index, t, userDelegateItem, handleDeleteClick, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	
	
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userDelegateItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userDelegateItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userDelegateItem.parentCompanyName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userDelegateItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
					<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, userDelegateItem)}>
						{userDelegateItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>

			</td>
		</tr>
	)
}
export default UserDelegateReadOnlyRow;